import React from 'react';
import { Input } from 'bootstrap';

/* eslint-disable react/prop-types */

const RadioMenuItem = ({ checked, label }) => {
  return (
    <div className="column-menu-input">
      <Input type="radio" checked={checked} />
      {label}
    </div>
  );
};

export default RadioMenuItem;
